const joinClasses = (...classes) => classes.filter(Boolean).join(" ");

export const MOBILE_SEARCH_ICON_CLASS = "!h-[26px] !w-[26px]";

export const MobileSearchFrame = ({
  as: Component = "div",
  useLayout = true,
  className = "",
  children,
  ...props
}) => (
  <Component
    className={joinClasses(
      useLayout &&
        "grid grid-cols-[32px_minmax(0,1fr)_32px] items-center gap-2",
      className
    )}
    {...props}
  >
    {children}
  </Component>
);

export const MobileSearchSideSlot = ({
  as: Component = "span",
  useBase = true,
  className = "",
  children,
  ...props
}) => (
  <Component
    className={joinClasses(
      useBase &&
        "flex h-11 w-8 min-w-0 shrink-0 items-center justify-center",
      className
    )}
    {...props}
  >
    {children}
  </Component>
);

export const MobileSearchFieldShell = ({
  as: Component = "div",
  useBase = true,
  className = "",
  children,
  ...props
}) => (
  <Component
    className={joinClasses(
      useBase &&
        "h-[42px] min-w-0 rounded-full border border-black/5 bg-white shadow-[0_2px_12px_rgba(0,0,0,0.14)] dark:border-white/10 dark:bg-white/10",
      className
    )}
    {...props}
  >
    {children}
  </Component>
);
